// 统计表
import axios from 'axios'
// 线上订单按收入统计(日)
export function getTotalOrderIncome(data) {
  return axios({
    url: `/totalDayOrderIncome`,
    method: 'get',
    params: data
  })
}

// 线上订单按收入统计(月)
export function getMonthOrderIncome(data) {
  return axios({
    url: `/totalMonthOrderIncome`,
    method: 'get',
    params: data
  })
}

// 线上订单按收入统计(年)
export function getYearOrderIncome(data) {
  return axios({
    url: `/totalYearOrderIncome`,
    method: 'get',
    params: data
  })
}

// 线上订单按商品统计(日)
export function getDayOrderProduct(data) {
  return axios({
    url: `/totalDayOrderProduct`,
    method: 'get',
    params: data
  })
}

// 线上订单按商品统计(月)
export function getMonthOrderProduct(data) {
  return axios({
    url: `/totalMonthOrderProduct`,
    method: 'get',
    params: data
  })
}

// 线上订单按商品统计(年)
export function getYearOrderProduct(data) {
  return axios({
    url: `/totalYearOrderProduct`,
    method: 'get',
    params: data
  })
}

// 线上订单正常衣物品类统计(日)
export function getDayOrderClothing(data) {
  return axios({
    url: `/totalDayNormalOrderClothing`,
    method: 'get',
    params: data
  })
}

// 线上订单正常衣物品类统计(月)
export function getMonthOrderClothing(data) {
  return axios({
    url: `/totalMonthNormalOrderClothing`,
    method: 'get',
    params: data
  })
}

// 线上订单正常衣物品类统计(年)
export function getYearOrderClothing(data) {
  return axios({
    url: `/totalYearNormalOrderClothing`,
    method: 'get',
    params: data
  })
}

// 线上订单退洗衣物品类统计(日)
export function getDayRefundClothing(data) {
  return axios({
    url: `/totalDayRefundOrderClothing`,
    method: 'get',
    params: data
  })
}

// 线上订单退洗衣物品类统计(月)
export function getMonthRefundClothing(data) {
  return axios({
    url: `/totalMonthRefundOrderClothing`,
    method: 'get',
    params: data
  })
}

// 线上订单退洗衣物品类统计(年)
export function getYearRefundClothing(data) {
  return axios({
    url: `/totalYearRefundOrderClothing`,
    method: 'get',
    params: data
  })
}

// 线上订单返洗衣物品类统计(日)
export function getDayReturnClothing(data) {
  return axios({
    url: `/totalDayReturnOrderClothing`,
    method: 'get',
    params: data
  })
}

// 线上订单返洗衣物品类统计(月)
export function getMonthReturnClothing(data) {
  return axios({
    url: `/totalMonthReturnOrderClothing`,
    method: 'get',
    params: data
  })
}

// 线上订单返洗衣物品类统计(年)
export function getYearReturnClothing(data) {
  return axios({
    url: `/totalYearReturnOrderClothing`,
    method: 'get',
    params: data
  })
}

// 线上订单按总检员统计(日)
export function getDayOrderDirector(data) {
  return axios({
    url: `/totalDayOrderDirector`,
    method: 'get',
    params: data
  })
}

// 线上订单按总检员统计(月)
export function getMonthOrderDirector(data) {
  return axios({
    url: `/totalMonthOrderDirector`,
    method: 'get',
    params: data
  })
}

// 线上订单按总检员统计(年)
export function getYearOrderDirector(data) {
  return axios({
    url: `/totalYearOrderDirector`,
    method: 'get',
    params: data
  })
}

// 线上订单按分检员统计(日)
export function getDayOrderSorting(data) {
  return axios({
    url: `/totalDayOrderSorting`,
    method: 'get',
    params: data
  })
}

// 线上订单按分检员统计(月)
export function getMonthOrderSorting(data) {
  return axios({
    url: `/totalMonthOrderSorting`,
    method: 'get',
    params: data
  })
}

// 线上订单按分检员统计(年)
export function getYearOrderSorting(data) {
  return axios({
    url: `/totalYearOrderSorting`,
    method: 'get',
    params: data
  })
}

// 线上订单按状态今日产能统计
export function getDayOrderStatus(data) {
  return axios({
    url: `/totalDayOrderStatus`,
    method: 'get',
    params: data
  })
}

// 线上订单按状态预警统计
export function getEWOrderStatus() {
  return axios({
    url: `/totalEWOrderStatus`,
    method: 'get',
  })
}

// 线上订单按状态预警统计-订单详情（点击柱状图，传预警类型 ewType）
export function getEWOrderStatusDetail(data) {
  return axios({
    url: `/totalEWOrderStatusDetail`,
    method: 'get',
    params: data
  })
}

// 线上订单按状态预警统计-订单子项详情（点击订单子项柱状图，传预警类型 ewType）
export function getEWOrderItemStatusDetail(data) {
  return axios({
    url: `/totalEWOrderItemStatusDetail`,
    method: 'get',
    params: data
  })
}

// 线上订单按状态当前工作量统计
export function getWorkOrderStatus() {
  return axios({
    url: `/totalWorkOrderStatus`,
    method: 'get',
  })
}

// 门店订单按正常衣物品类统计(日)
export function getDayNormalOfflineClothing(data) {
  return axios({
    url: `/totalDayNormalOrderOfflineClothing`,
    method: 'get',
    params: data
  })
}

// 门店订单按正常衣物品类统计(月)
export function getMonthNormalOfflineClothing(data) {
  return axios({
    url: `/totalMonthNormalOrderOfflineClothing`,
    method: 'get',
    params: data
  })
}

// 门店订单按正常衣物品类统计(年)
export function getYearNormalOfflineClothing(data) {
  return axios({
    url: `/totalYearNormalOrderOfflineClothing`,
    method: 'get',
    params: data
  })
}

// 门店订单按退洗衣物品类统计(日)
export function getDayRefundOfflineClothing(data) {
  return axios({
    url: `/totalDayRefundOrderOfflineClothing`,
    method: 'get',
    params: data
  })
}

// 门店订单按退洗衣物品类统计(月)
export function getMonthRefundOfflineClothing(data) {
  return axios({
    url: `/totalMonthRefundOrderOfflineClothing`,
    method: 'get',
    params: data
  })
}

// 门店订单按退洗衣物品类统计(年)
export function getYearRefundOfflineClothing(data) {
  return axios({
    url: `/totalYearRefundOrderOfflineClothing`,
    method: 'get',
    params: data
  })
}

// 门店订单按返洗衣物品类统计(日)
export function getDayReturnOfflineClothing(data) {
  return axios({
    url: `/totalDayReturnOrderOfflineClothing`,
    method: 'get',
    params: data
  })
}

// 门店订单按返洗衣物品类统计(月)
export function getMonthReturnOfflineClothing(data) {
  return axios({
    url: `/totalMonthReturnOrderOfflineClothing`,
    method: 'get',
    params: data
  })
}

// 门店订单按返洗衣物品类统计(年)
export function getYearReturnOfflineClothing(data) {
  return axios({
    url: `/totalYearReturnOrderOfflineClothing`,
    method: 'get',
    params: data
  })
}

// 门店订单按总检员统计(日)
export function getDayOrderOfflineDirector(data) {
  return axios({
    url: `/totalDayOrderOfflineDirector`,
    method: 'get',
    params: data
  })
}
// 门店订单按总检员统计(月)
export function getMonthOrderOfflineDirector(data) {
  return axios({
    url: `/totalMonthOrderOfflineDirector`,
    method: 'get',
    params: data
  })
}
// 门店订单按总检员统计(年)
export function getYearOrderOfflineDirector(data) {
  return axios({
    url: `/totalYearOrderOfflineDirector`,
    method: 'get',
    params: data
  })
}
// 门店订单按收入统计(日)
export function getDayOrderOfflineIncome(data) {
  return axios({
    url: `/totalDayOrderOfflineIncome`,
    method: 'get',
    params: data
  })
}
// 门店订单按收入统计(月)
export function getMonthOrderOfflineIncome(data) {
  return axios({
    url: `/totalMonthOrderOfflineIncome`,
    method: 'get',
    params: data
  })
}
// 门店订单按收入统计(年)
export function getYearOrderOfflineIncome(data) {
  return axios({
    url: `/totalYearOrderOfflineIncome`,
    method: 'get',
    params: data
  })
}
// 门店订单按商品统计(日)
export function getDayOrderOfflineProduct(data) {
  return axios({
    url: `/totalDayOrderOfflineProduct`,
    method: 'get',
    params: data
  })
}
// 门店订单按商品统计(月)
export function getMonthOrderOfflineProduct(data) {
  return axios({
    url: `/totalMonthOrderOfflineProduct`,
    method: 'get',
    params: data
  })
}
// 门店订单按商品统计(年)
export function getYearOrderOfflineProduct(data) {
  return axios({
    url: `/totalYearOrderOfflineProduct`,
    method: 'get',
    params: data
  })
}
// 门店订单按分检员统计(日)
export function getDayOrderOfflineSorting(data) {
  return axios({
    url: `/totalDayOrderOfflineSorting`,
    method: 'get',
    params: data
  })
}
// 门店订单按分检员统计(月)
export function getMonthOrderOfflineSorting(data) {
  return axios({
    url: `/totalMonthOrderOfflineSorting`,
    method: 'get',
    params: data
  })
}
// 门店订单按分检员统计(年)
export function getYearOrderOfflineSorting(data) {
  return axios({
    url: `/totalYearOrderOfflineSorting`,
    method: 'get',
    params: data
  })
}
// 门店订单按送件司机统计(日)
export function getDayOrderOfflineScDriver(data) {
  return axios({
    url: `/totalDayOrderOfflineScDriver`,
    method: 'get',
    params: data
  })
}
// 门店订单按送件司机统计(月)
export function getMonthOrderOfflineScDriver(data) {
  return axios({
    url: `/totalMonthOrderOfflineScDriver`,
    method: 'get',
    params: data
  })
}
// 门店订单按送件司机统计(年)
export function getYearOrderOfflineScDriver(data) {
  return axios({
    url: `/totalYearOrderOfflineScDriver`,
    method: 'get',
    params: data
  })
}
// 门店订单按驿站统计(日)
export function getDayOrderOfflineStage(data) {
  return axios({
    url: `/totalDayOrderOfflineStage`,
    method: 'get',
    params: data
  })
}
// 门店订单按驿站统计(月)
export function getMonthOrderOfflineStage(data) {
  return axios({
    url: `/totalMonthOrderOfflineStage`,
    method: 'get',
    params: data
  })
}
// 门店订单按驿站统计(年)
export function getYearOrderOfflineStage(data) {
  return axios({
    url: `/totalYearOrderOfflineStage`,
    method: 'get',
    params: data
  })
}
// 门店订单按取件司机统计(日)
export function getDayOrderOfflineTcDriver(data) {
  return axios({
    url: `/totalDayOrderOfflineTcDriver`,
    method: 'get',
    params: data
  })
}
// 门店订单按取件司机统计(月)
export function getMonthOrderOfflineTcDriver(data) {
  return axios({
    url: `/totalMonthOrderOfflineTcDriver`,
    method: 'get',
    params: data
  })
}
// 门店订单按取件司机统计(年)
export function getYearOrderOfflineTcDriver(data) {
  return axios({
    url: `/totalYearOrderOfflineTcDriver`,
    method: 'get',
    params: data
  })
}
// 门店订单按状态今日产能统计
export function getDayOrderOfflineStatus(data) {
  return axios({
    url: `/totalDayOrderOfflineStatus`,
    method: 'get',
    params: data
  })
}
// 门店订单按状态预警统计
export function getEWOrderOfflineStatus() {
  return axios({
    url: `/totalEWOrderOfflineStatus`,
    method: 'get',
  })
}

// 门店订单按状态预警统计-订单详情（点击柱状图，传预警类型 ewType）
export function getEWOrderOfflineStatusDetail(data) {
  return axios({
    url: `/totalEWOrderOfflineStatusDetail`,
    method: 'get',
    params: data
  })
}

// 门店订单按状态当前工作量统计
export function getWorkOrderOfflineStatus() {
  return axios({
    url: `/totalWorkOrderOfflineStatus`,
    method: 'get',
  })
}


// 用户渠道消费明细统计(日)
export function getDayMemberCON(data) {
  return axios({
    url: `/totalDayMemberCON`,
    method: 'get',
    params: data
  })
}
// 用户渠道消费明细统计(月)
export function getMonthMemberCON(data) {
  return axios({
    url: `/totalMonthMemberCON`,
    method: 'get',
    params: data
  })
}
// 用户渠道消费明细统计(年)
export function getYearMemberCON(data) {
  return axios({
    url: `/totalYearMemberCON`,
    method: 'get',
    params: data
  })
}
// 用户渠道充值明细统计(日)
export function getDayMemberRE(data) {
  return axios({
    url: `/totalDayMemberRE`,
    method: 'get',
    params: data
  })
}
// 用户渠道充值明细统计(月)
export function getMonthMemberRE(data) {
  return axios({
    url: `/totalMonthMemberRE`,
    method: 'get',
    params: data
  })
}
// 用户渠道充值明细统计(年)
export function getYearMemberRE(data) {
  return axios({
    url: `/totalYearMemberRE`,
    method: 'get',
    params: data
  })
}


// 小商品订单按收入统计
export function getSmallOrderIncome(data) {
  return axios({
    url: `/totalSmallOrderIncome`,
    method: 'get',
    params: data
  })
}
// 小商品订单按商品统计
export function getSmallOrderProduct(data) {
  return axios({
    url: `/totalSmallOrderProduct`,
    method: 'get',
    params: data
  })
}
// 小商品订单按状态统计
export function getSmallOrderStatus(data) {
  return axios({
    url: `/totalSmallOrderStatus`,
    method: 'get',
    params: data
  })
}

